import styled from '@emotion/styled';

import { Card, CardHeader, CardContent, Skeleton } from '@mui/material';

import StatBlock from '../../../utils/utilities/StatBlock';

// icons
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import NoAccountsRoundedIcon from '@mui/icons-material/NoAccountsRounded';
import EventBusyRoundedIcon from '@mui/icons-material/EventBusyRounded';

import { BasicFlex } from '../../../utils/Common';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';

import useIsMobile from '../../../hooks/useIsMobile';

const AppointmentHistory = ({ history = {}, loading, client_name }) => {
  const { cancelled_count, no_show_count, completed_count } = history;

  const { isMobile } = useIsMobile();
  
  return (
    <Card sx={{width: "fit-content", backgroundColor: "transparent", width: "100%"}} elevation={0}>
      <CardHeader title={`Appointment History ${client_name ? `for ${client_name}` : ""}`} sx={{p: isMobile ? 0 : 1}} />
      <CardContent sx={{p: isMobile ? 0 : 1, pt: 1.5, pb: '1rem !important'}}>
        {/* <CardBlockContainer>
          {clientBlock.map((block) => (
            <CardBlock key={block.header} {...block} />
          ))}
          <CardSpacer />
        </CardBlockContainer> */}
        {loading ? <BasicFlex justify="center" gap="2rem">
          <Skeleton variant="rounded" width={180} height={60} />
          <Skeleton variant="rounded" width={180} height={60} />
          <Skeleton variant="rounded" width={180} height={60} />
        </BasicFlex> : 
        <BasicFlex justify="center" gap={isMobile ? "1.5rem" : "2rem"}>
          <StatBlock stat={completed_count} Icon={EventAvailableRoundedIcon} title="Show" palette="success" />
          <StatBlock stat={no_show_count} Icon={EventBusyRoundedIcon} title="No Show" palette="warning" />
          <StatBlock stat={cancelled_count} Icon={NoAccountsRoundedIcon} title="Cancelled" palette="error" />
        </BasicFlex>}
      </CardContent>
    </Card>
  );
};

export default AppointmentHistory;